





















































































































































































































































































import { PushDetailItemInfo } from "@/store/push/statistic/types";
import { dateFilter } from "@/utils/date-util";
import { notifyError, notifySuccess } from "@/utils/notify-helper";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { colorClassByStatus } from "@/utils/page-utils";
import axios from "axios";
import {getTranslatedParams} from "@/utils/notify-utils";
import {MsgTransports} from "@/store/types";
import {ActionLog} from "@/store/auth/types";

@Component({
  components: {},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class PushDetailInfo extends Vue {
  @Action("getPushStatisticDetailInfo") actionGetItem: any;
  @Action("resendPushMessage") actionResendMessage: any;
  @Action("actionLog") actionLog: any;

  private messageInfo: PushDetailItemInfo = new PushDetailItemInfo();
  private transport = MsgTransports.PUSH;
  private logObject: ActionLog = {};

  get isShowFinInf(): boolean {
    return localStorage.getItem('show-finance-info') === 'true';
  }

  async created(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      this.messageInfo = await this.actionGetItem(this.$route.params.id);
      await this.actionLog(this.logObject);
    } catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  back(): void {
    this.$router.push('/push/detail/');
  }

  async resend(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Resending",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      const resp = await this.actionResendMessage(this.$route.params.id);
      await this.actionLog(this.logObject);
      if (resp.data.status === 'Success') {
        notifySuccess(this.$t('dialog.resend').toString());
      } else {
        notifyError();
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }
}
